(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-premium-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-aura-premium-product]').forEach((section) => {
    if (section.dataset.auraInitialized === 'true') return;
    section.dataset.auraInitialized = 'true';

    const variantsData = section.querySelector('[data-aura-variants]');
    const variants = variantsData ? JSON.parse(variantsData.textContent) : [];
    const currency = section.dataset.currency || 'INR';
    const variantInput = section.querySelector('[data-aura-variant-id]');
    const price = section.querySelector('[data-aura-price]');
    const compare = section.querySelector('[data-aura-compare]');
    const sale = section.querySelector('[data-aura-sale]');
    const inventory = section.querySelector('[data-aura-inventory]');
    const addButton = section.querySelector('[data-aura-add]');
    const addLabel = section.querySelector('[data-aura-add-label]');
    const sticky = section.querySelector('[data-aura-sticky]');
    const stickyButton = section.querySelector('[data-aura-sticky-add]');
    const stickyPrice = section.querySelector('[data-aura-sticky-price]');
    const inStockLabel = section.dataset.inStockLabel;
    const soldOutLabel = section.dataset.soldOutLabel;
    const addToCartLabel = section.dataset.addToCartLabel;
    const offLabel = section.dataset.offLabel;

    const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0
    }).format(cents / 100);

    section.querySelectorAll('[data-aura-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const mediaId = thumb.dataset.auraThumb;
        section.querySelectorAll('[data-aura-media]').forEach((media) => {
          const active = media.dataset.auraMedia === mediaId;
          media.hidden = !active;
          media.classList.toggle('is-active', active);
        });
        section.querySelectorAll('[data-aura-thumb]').forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });

    const quantity = section.querySelector('[data-aura-quantity]');
    section.querySelector('[data-aura-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    section.querySelector('[data-aura-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });

    const updateVariant = () => {
      const selected = Array.from(section.querySelectorAll('[data-option-position]:checked'))
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map((input) => input.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;

      variantInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.classList.toggle('is-hidden', !onSale);
      sale.classList.toggle('is-hidden', !onSale);

      if (onSale) {
        compare.textContent = formatMoney(variant.compare_at_price);
        const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        sale.textContent = discount + '% ' + offLabel;
      }

      addButton.disabled = !variant.available;
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? addToCartLabel : soldOutLabel;
      }
      inventory.classList.toggle('is-sold-out', !variant.available);
      inventory.lastChild.textContent = variant.available ? inStockLabel : soldOutLabel;
      addLabel.textContent = variant.available ? addToCartLabel : soldOutLabel;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    section.querySelectorAll('[data-option-position]').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    if (sticky && stickyButton && addButton) {
      stickyButton.addEventListener('click', () => addButton.click());
      const buyObserver = new IntersectionObserver((entries) => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: .2 });
      buyObserver.observe(addButton);
    }

    const recommendations = section.querySelector('[data-aura-recommendations]');
    if (recommendations && !recommendations.innerHTML.trim()) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        fetch(recommendations.dataset.url)
          .then((response) => response.text())
          .then((htmlText) => {
            const html = new DOMParser().parseFromString(htmlText, 'text/html');
            const replacement = html.querySelector('[data-aura-recommendations]');
            if (replacement) recommendations.innerHTML = replacement.innerHTML;
          });
      }, { rootMargin: '300px 0px' });
      observer.observe(recommendations);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
